import { medium } from "../size/index.js";
import container from "../container/container.js";
import defineElement from "../helpers/defineElement.js";

/**
 * Wrap its children to add padding, border-radius, border color,
 * background and color according to the current theme.
 *
 * @param {object} [options]
 * @param {ElementSize} [options.size] - Size of the space
 *   between each child
 */

export default defineElement(
	"card",
	({ size = medium, fullWidth }, children) => ({
		options: {},
		children: container(
			{
				around: true,
				fullWidth,
				size,
			},
			...children,
		),
	}),
);
